import { useEffect, useState } from "react";
import { observer } from 'mobx-react';
import { useStores } from 'stores/index';
import { useParams } from "react-router-dom";

//@ts-ignore
import { useFilterParams, Tab, Loading, EmptyPage, Avatar } from '@microui/react-ui';
import Listing from "./Listing"

const ClientTenant = () => {
    const { id } = useParams();
    const { clientStore } = useStores();
    const { params, setParams } = useFilterParams();
    const [search, setSearch] = useState(params?.keyword);
    const [tab, setTab] = useState('');
    const [loadingInfo, setLoadingInfo] = useState(true);
    const [loadingTenant, setLoadingTenant] = useState(true);
    const [clientInfo, setClientInfo] = useState(null);
    const [tenantData, setTenantData] = useState([]);
    const tablist = [
        {
            key: 'tab1',
            title: 'TẤT CẢ KÊNH',
            component: <Listing loading={loadingTenant} data={tenantData} info={clientInfo} />
        },
        {
            key: '2',
            title: 'KÊNH SỞ HỮU',
            component: <Listing loading={loadingTenant} data={tenantData} info={clientInfo} />
        }
    ];

    useEffect(() => {
        if (!params.tab) {
            setTab(tablist[0].key);
        } else {
            setTab(params.tab)
        }

    }, [params]);

    useEffect(() => {
        clientStore.getClient(id)
            .then(data => setClientInfo(data))
            .finally(() => setLoadingInfo(false));

        clientStore.getTenants(id)
            .then(data => setTenantData(data))
            .finally(() => setLoadingTenant(false));
    }, []);

    if (loadingInfo)
        return <Loading size="large" loadingText="Đang tải thông tin kênh" />;

    if (!clientInfo)
        return <EmptyPage />;

    return (
        <Tab
            handleSearch={(val) => {
                setParams({ ...params, keyword: val });
            }}
            searchValue={search}
            handleSearchChange={(val) => {
                setSearch(val)
            }}
            detail={
                <div className="mt-[32px] pl-[24px]">
                    <div className="flex gap-[20px]">
                        <div className="w-[120px] h-[120px] bg-white justify-center items-center flex rounded-full">
                            <Avatar
                                size='large'
                                value={clientInfo?.avatar || clientInfo?.clientName}
                            />
                        </div>
                        <div className="flex-1 flex flex-col justify-center">
                            <div className="text-headline-1 font-[700] text-white cursor-pointer">
                                {clientInfo?.clientName}
                            </div>
                            <div className="text-body-2 text-white mt-[6px]">
                                {clientInfo?.description}
                            </div>
                        </div>
                    </div>
                </div>
            }
            currentTabKey={tab}
            handleTabChange={(tab) => {
                setParams({ ...params, tab: tab.key });
                setTab(tab.key);
            }}
            tabList={tablist}
        />
    );
}

export default ClientTenant;